export default "__VITE_ASSET__DamsNl2f__"